import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { OrderHistoricService } from 'src/app/services/marina-order/order-historic.service';
import { CurrencyService } from 'src/app/services/currency.service';
import { Currency } from 'src/app/models/enums/currency';
import { CurrencyUtil } from 'src/app/utils/currency.util';

@Component({
  selector: 'app-order-historic',
  templateUrl: './order-historic.component.html',
  styleUrls: ['./order-historic.component.scss']
})
export class OrderHistoricComponent implements OnInit {

  marinaOrder: any;
  historic: any[];
  currentCurrency: Currency = Currency.BRL;

  constructor(
    public dialogRef: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private orderHistoricService: OrderHistoricService,
    private currencyService: CurrencyService
  ) {
    this.marinaOrder = this.config.data.marinaOrder
   }

  ngOnInit(): void {
    this.currentCurrency = this.currencyService.getCurrentCurrency();

    console.log(this.marinaOrder);
    
    this.orderHistoricService.findHistoricByMarinaOrder(this.marinaOrder).subscribe((response) => {
      this.historic = response;
      
      if (this.currentCurrency !== Currency.BRL && this.historic) {
        this.historic.forEach(item => {
          if (item.description && item.description.includes('R$')) {
            item.description = item.description.replace(/R\$/g, CurrencyUtil.getCurrencySymbol(this.currentCurrency));
          }
        });
      }
    });
  }

}
